import { Component, Logger } from 'lib'
import Home from 'Container/Home/Home'
import News from 'Container/News/News'
import Schedule from 'Container/Schedule/Schedule'
import Rewards from 'Container/Rewards/Rewards'
import Standings from 'Container/Standings/Standings'
import WatchLive from 'Container/Watch/Live/WatchLive'
import WatchVod from 'Container/Watch/Vod/WatchVod'
import Vods from 'Container/Vods/Vods'
import Team from 'Container/Team/Team'
import GlobalPartners from 'Container/GlobalPartners/GlobalPartners'
import Video from 'Container/Video/Video'
import Article from 'Container/Article/Article'
import Settings from 'Container/Settings/Settings'
import {
  AnalyticsEventTypes,
  AnalyticsPages
} from 'Common/Service/Analytics/constants'

const containers = {
  Home,
  News,
  Schedule,
  Rewards,
  Standings,
  WatchLive,
  WatchVod,
  Vods,
  Team,
  GlobalPartners,
  Video,
  Article,
  Settings
}

const pageNames = {
  GlobalPartners: AnalyticsPages.GlobalPartners,
  WatchLive: AnalyticsPages.Live,
  Rewards: AnalyticsPages.Rewards,
  Settings: AnalyticsPages.Settings,
  Team: AnalyticsPages.Team,
  Standings: AnalyticsPages.TournamentStandings,
  WatchVod: AnalyticsPages.Vod,
  Vods: AnalyticsPages.Vods
}

class Container extends Component {
  /**
   * @type {{ analyticsService: import('Common/Service/Analytics/types').IAnalyticsService }}
   */
  context

  constructor () {
    super()
    this.log = new Logger(this.constructor.name)
  }

  componentDidMount () {
    const name = this.props.path?.split('/')?.pop() || ''
    const pageName = pageNames[name]

    if (!pageName) {
      return
    }

    this.context.analyticsService.track(AnalyticsEventTypes.PageView, {
      name: pageName
    })
  }

  componentDidUpdate () {
    // make sure scrolled containers go back top
    window.scrollTo(0, 0)
  }

  render () {
    const name = this.props.path?.split('/')?.pop() || ''

    // since legacy routes like /schedule are not supported for
    // local development, this prevents JS from breaking
    if (!name) {
      this.log.warn('Unsupported route')
      return
    }

    this.log.info('Loaded', name)
    const MyContainer = containers[name]

    return <MyContainer/>
  }
}

export default Container
